import gql from 'graphql-tag'

export const DELETE = gql`
  mutation discount_delete($id: ID!) {
    discountDelete(id: $id)
  }
`
